import React, {useState} from "react";
import { Box, Button, Column, Columns, Control, Field, Input, TextArea, Title } from "@allxsmith/bestax-bulma";
import {useDispatch} from "react-redux";
import axios from "axios";
import {ToastContainer, toast} from "react-toastify";
import Nav from "../../Nav/Nav";


// 15 Oct (Neil): phone/email enquiries capture everything needed to quote with carriage - reg, phone,
// email, postcode and the parts are required. The enquiry is created on the MANUAL (CASH SALE)
// customer with these filled in, so "Calculate postage" picks up the postcode straight away.
export default function PartEnquiryForm(props){

    const [description, setDescription] = useState("");
    const [registration, setRegistration] = useState("");
    const [make, setMake] = useState();
    const [model, setModel] = useState();
    const [name, setName] = useState("");
    const [phone, setPhone] = useState("");
    const [email, setEmail] = useState("");
    const [postcode, setPostcode] = useState("");
    const [saving, setSaving] = useState(false);
    const dispatch = useDispatch();

    const REQUIRED = [["registration", "Registration"], ["phone", "Telephone number"], ["email", "Email address"],
                      ["postcode", "Postcode"], ["description", "Description of parts"]];

    const validator = (enquiry) => {
        const missing = REQUIRED.filter(([k]) => !(enquiry[k] || "").trim()).map(([, label]) => label);
        if (missing.length) {
            toast.warning("Please fill in: " + missing.join(", "), {position: "top-right"});
            return false;
        }
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(enquiry.email.trim())) {
            toast.warning("That email address doesn't look right", {position: "top-right"});
            return false;
        }
        if (!/^[A-Z]{1,2}[0-9][A-Z0-9]? ?[0-9][A-Z]{2}$/i.test(enquiry.postcode.trim())) {
            toast.warning("That postcode doesn't look right", {position: "top-right"});
            return false;
        }
        return true;
    }

    const onSave = () => {
        let enquiry = {
            description: description,
            registration: registration,
            make: make,
            model: model,
            name: name,
            phone: phone,
            email: email,
            postcode: postcode
        };
        if(validator(enquiry)){
            setSaving(true);
            const conf = {
              method: "post",
              data: enquiry,
              url: "api/createpartenquiry"
            };
            axios(conf).then((res) => {
              if (res) {
               window.open("/editpartorder/" + res.data.id, "_self")
              }
            }).catch(err => {
              setSaving(false);
              const d = err.response && err.response.data;
              toast.error((d && d.detail) || JSON.stringify(d || "Could not create the enquiry"), {position: "top-right"});
            });
        }
    }

    const req = <span className="has-text-danger"> *</span>;

    return (
        <div>
            <Nav/>
            <Box>
                <Title>Part Enquiry</Title>
                <Columns isMultiline>
                    <Column>
                        <Field>
                            <label className="label">Vehicle Registration{req}</label>
                            <Control>
                                <Input
                                    type={"text"}
                                    value={registration}
                                    onInput={(e) => setRegistration(e.target.value.toUpperCase())}
                                />
                            </Control>
                        </Field>
                    </Column>
                    <Column>
                        <Field>
                            <label className="label">Enquiry Vehicle Make</label>
                            <Control>
                                <Input
                                    type={"text"}
                                    onInput={(e) => setMake(e.target.value)}
                                />
                            </Control>
                        </Field>
                    </Column>
                    <Column>
                        <Field>
                            <label className="label">Enquiry Vehicle Model</label>
                            <Control>
                                <Input
                                    type={"text"}
                                    onInput={(e) => setModel(e.target.value)}
                                />
                            </Control>
                        </Field>
                    </Column>
                </Columns>
                <Columns isMultiline>
                    <Column>
                        <Field>
                            <label className="label">Customer Name</label>
                            <Control>
                                <Input type={"text"} value={name} onInput={(e) => setName(e.target.value)}/>
                            </Control>
                        </Field>
                    </Column>
                    <Column>
                        <Field>
                            <label className="label">Telephone Number{req}</label>
                            <Control>
                                <Input type={"tel"} value={phone} onInput={(e) => setPhone(e.target.value)}/>
                            </Control>
                        </Field>
                    </Column>
                    <Column>
                        <Field>
                            <label className="label">Email Address{req}</label>
                            <Control>
                                <Input type={"email"} value={email} onInput={(e) => setEmail(e.target.value)}/>
                            </Control>
                        </Field>
                    </Column>
                    <Column>
                        <Field>
                            <label className="label">Postcode{req}</label>
                            <Control>
                                <Input type={"text"} value={postcode} onInput={(e) => setPostcode(e.target.value.toUpperCase())}/>
                            </Control>
                        </Field>
                    </Column>
                </Columns>
                <Columns isMultiline>
                    <Column>
                        <Field>
                            <label className="label">Description of Parts{req}</label>
                            <TextArea
                                value={description}
                                onInput={(e) => setDescription(e.target.value)}
                            />
                        </Field>
                    </Column>
                </Columns>
                <Columns isMultiline>
                    <Column>
                        <Button
                            color={"success"}
                            onClick={onSave}
                            disabled={saving}
                            isFullWidth
                        >
                            {saving ? "Creating..." : "Create Part Enquiry"}
                        </Button>
                    </Column>
                </Columns>
            </Box>
        </div>
    );



}
